import replaceIframe from './replaceIframe'

export default replaceIframe
